<template>
  <div class="remark">
      这里是说明
  </div>
</template>

<script>
export default {
  name: "remark",
  data() {
      return {
          form: {}
      }
  }
};
</script>

<style lang="scss" scoped>
</style>